<template>
  <v-row>
    <v-col md="12">
      <h3>Atencion al Beneficiario</h3>
    </v-col>
    <v-col md="12">
      <h4>{{ Cantidades }}</h4>
    </v-col>
    <v-col md="12">
      <lista
        :items="ListaPorArea"
        v-if="!selected"
        tomar
        v-model="selected"
      ></lista>
    </v-col>
    <v-col md="12" v-if="!selected">
      <v-pagination
        v-model="pagina"
        :length="Paginas"
        :total-visible="15"
      ></v-pagination>
    </v-col>
    <v-col md="12">
      <h3 class="green--text" v-if="selected && !esSoloDeriva">
        Al estar pendiente se puede modificar
      </h3>
      <Modificar
        :soloderiva="esSoloDeriva"
        v-if="selected"
        :idsolic="selected.id_solic"
        @guardado="guardado()"
      ></Modificar>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Modificar from "@/components/Practica/Modificar";
import usuario from "@/components/Usuarios/TraerNombre";
import lista from "@/components/Practica/Lista";
export default {
  components: {
    Modificar,
    usuario,
    lista,
  },
  props: ["id_afiliado"],
  created() {
    if (this.sinmanejador[1]) {
      this.setManejador(1);
      this.$msjpusher.$on("practica-tomada", this.practicatomada);
      this.$msjpusher.$on("practica-guardada", this.practicaguardada);
    }
  },
  // destroyed() {
  //   // this.$msjpusher.$on("practica-tomada", this.practicatomada);
  //   // this.$msjpusher.$on("practica-guardada", this.practicaguardada);

  //   this.$msjpusher.$on("practica-tomada", (datos) => {});
  //   this.$msjpusher.$on("practica-guardada", (datos) => {});
  // },
  data() {
    return {
      pagina: 1,
      selected: undefined,
    };
  },
  computed: {
    ...mapState("comun", ["sinmanejador", "bandejaactual"]),
    ...mapState('autorizaciones', ['ListaPorArea', 'Paginas', 'Filtros', 'Cantidades']),
    ...mapState("areas", { listaareas: "Lista" }),
    esSoloDeriva() {
      let ret = false;
       if (
        this.selected &&
        this.selected.tipo != 5 &&
        this.selected.estado != 1
      ) {
        ret = true;
      }
      return ret;
    },
  },
  methods: {
    ...mapActions('autorizaciones', ['traerPorAreaPaginado', 'resetFiltros']),
    ...mapActions("comun", ["setBandeja", "setManejador"]),
    practicatomada(datos) {
      let autoriz = this.ListaPorArea.find(
        (x) => x.id_solic === datos.id_solic
      );
      if (autoriz) {
        autoriz.TomadaPor = datos.id_user;
      }
    },
    practicaguardada(datos) {
      if (datos.id_area == 1 && this.bandejaactual == 1) {
        this.traerPorAreaPaginado({ id_area: 1, pagina: this.pagina })

      }
    },
    guardado() {
      this.selected = undefined;
      //this.traerPorArea(1);
    },
    getColor(id_estado) {
      let ret = "lime lighten-4";
      switch (id_estado) {
        case 1:
          ret = "red";
          break;
        case 2:
          ret = "green";
          break;
        case 3:
          ret = "blue";
          break;
        case 4:
          ret = "black";
          break;
        case 5:
          ret = "white";
          break;
        default:
          break;
      }
      return ret;
    },
  },
  watch: {
    pagina() {
      this.traerPorAreaPaginado({ id_area: 1, pagina: this.pagina })
    },
    Filtros() {
      this.pagina = 1
      this.traerPorAreaPaginado({ id_area: 1, pagina: 1 })
    }
  },
  mounted() {
    this.setBandeja(1);
    this.traerPorAreaPaginado({ id_area: 1, pagina: this.pagina })
    this.resetFiltros()
  },
};
</script>
